import React from 'react';
import { ImageIcon, PlayIcon } from 'lucide-react';
type MediaSlotProps = {
  /** Végleges kép URL. Ha üres, semleges helykitöltő jelenik meg. */
  src?: string;
  alt: string;
  /** Belső azonosító a csere megkönnyítéséhez (nem látható). */
  slot: string;
  aspect?: string;
  fit?: 'cover' | 'contain';
  kind?: 'image' | 'video';
  className?: string;
};
export function MediaSlot({
  src,
  alt,
  slot,
  aspect = 'aspect-square',
  fit = 'cover',
  kind = 'image',
  className = ''
}: MediaSlotProps) {
  if (src) {
    return <img src={src} alt={alt} data-slot={slot} loading="lazy" className={`${aspect} w-full ${fit === 'cover' ? 'object-cover' : 'object-contain bg-white'} ${className}`} data-id="element-187" data-mp="1wfsfly8odlwv" />;
  }
  const Icon = kind === 'video' ? PlayIcon : ImageIcon;
  return <div data-slot={slot} role="img" aria-label={alt} className={`${aspect} flex w-full items-center justify-center border-2 border-dashed border-lavender-line bg-[#F6F1FA] ${className}`} data-id="element-188" data-mp="18owt9gmznix0">
      <Icon className="h-10 w-10 text-lavender/70" strokeWidth={1.5} aria-hidden="true" data-id="element-189" data-mp="1bapyfnbfgdpv" />
    </div>;
}